export default __webpack_public_path__ + "static/media/package_7.99c0572e.png";